import {
    CANCEL_POLICY_API_REQUEST,
    CANCEL_POLICY_API_SUCCESS,
    CANCEL_POLICY_API_ERROR,
} from '../../../constants/quoteActionNames';

import cancelPolicyApi from '../../../apis/portfolio/cancelPolicyApi';

function cancelPolicyRequest() {
    return {
        type: CANCEL_POLICY_API_REQUEST,
        payload: true,
    };
}

function cancelPolicySuccess(data, params) {
    return {
        type: CANCEL_POLICY_API_SUCCESS,
        payload: data,
        params,
    };
}

function cancelPolicyError(err) {
    return {
        type: CANCEL_POLICY_API_ERROR,
        payload: err,
    };
}

export function cancelPolicyAction(params) {
    return (dispatch, getState) => {
        const state = getState();

        dispatch(cancelPolicyRequest());
        return cancelPolicyApi.cancelPolicy(state, params)
            .then(data => {
                dispatch(cancelPolicySuccess(data, params));
                return data;
            })
            .catch(error => {
                dispatch(cancelPolicyError(error));
                throw error;
            });
    };
}

export default { cancelPolicyAction };
